/* */
import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import actions from 'redux/actions';

const { getDomain } = actions;

export default (idDomainGroup) => {
  const authReducer = useSelector((state) => state.authReducer, shallowEqual);
  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      dispatch(getDomain({ idDomainGroup }));
    }
  }, [authReducer.isLogin]);
};
